// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__1d1Pw","Logo":"Toolbar_Logo__1Cs_l","DesktopOnly":"Toolbar_DesktopOnly__2NK_I"};